<template>
    <div>
        <div class="d-flex justify-content-between mx-3">
            <h6 class="text-primary mb-0">{{ title }}</h6>
            <i
                class="fas fa-trash clickable"
                style="font-size: 1rem"
                @click="$emit('delete')"
            />
        </div>

        <hr class="bg-primary my-2">

        <div class="container-with-elements mx-3">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MultipleCardItem",
        props: {
            title: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style scoped>
</style>